<template>
  <section class="contact-section">
    <div>
      <div class="row">
        <div class="col-lg-5 map-content">
          <div class="contact-info">
            <div class="info-item mt-5">
              <div
                class="info-content"
                data-aos="fade-down"
                data-aos-delay="50"
                data-aos-duration="500"
              >
                <h5 class="info-title mb-1">
                  <i class="fas fa-map-marker-alt"></i>العنوان
                </h5>
                <p>
                  الرياض - حي الوادي - طريق الشيخ عبدالله المخضوب<br />المملكة
                  العربية السعودية
                </p>
              </div>
              <div
                class="info-content"
                data-aos="fade-down"
                data-aos-delay="150"
                data-aos-duration="500"
              >
                <h5 class="info-title mt-3">
                  <i class="fa-regular fa-envelope"></i>البريد الإلكتروني
                </h5>
                <a href="mailto:Info@derayah-ksa.com" class="email-info"
                  >Info@derayah-ksa.com</a
                >
              </div>
              <div
                class="info-content"
                data-aos="fade-down"
                data-aos-delay="250"
                data-aos-duration="500"
              >
                <h5 class="info-title my-3">رقم التواصل</h5>
                <p>
                  <img
                    src="/assets/images/icons/whatsapp-icon.png"
                    alt="واتساب دراية"
                  />920013370
                </p>
                <p>
                  <img
                    src="/assets/images/icons/phone.png"
                    alt="رقم دراية"
                  />920013370
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="map-container">
            <iframe
              src="https://www.google.com/maps?q=24.793148040771484,46.697532653808594&z=17&hl=en&output=embed"
              width="100%"
              height="450"
              style="border: 0"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
